module.exports = __webpack_public_path__ + "img/probability_up_cn.b035c2ba.png";